import { darkColors, lightColors } from "../tokens/colors";

/** Maps legacy `C` keys to semantic CSS custom properties (for new style strings). */
export const LEGACY_C_KEYS_TO_CSS_VAR = Object.freeze({
  bg: "--tra-color-background",
  bgMid: "--tra-color-background-mid",
  bgTop: "--tra-color-background-top",
  surf: "--tra-color-surface",
  card: "--tra-color-surface-raised",
  bdr: "--tra-color-border-strong",
  bdrSoft: "--tra-color-border",
  bdrBr: "--tra-color-border-bright",
  sA: "--tra-color-team-a",
  sB: "--tra-color-team-b",
  gr: "--tra-color-primary",
  grDim: "--tra-color-primary-muted",
  net: "--tra-color-court-net",
  acc: "--tra-color-accent",
  orange: "--tra-color-accent",
  txt: "--tra-color-text",
  txtM: "--tra-color-text-muted",
  txtD: "--tra-color-text-dim",
  lav: "--tra-color-text-secondary",
  win: "--tra-color-success",
  loss: "--tra-color-danger",
  purple: "--tra-color-purple",
});

/**
 * @param {string} hex #rrggbb
 * @param {string} alphaHex two-char hex alpha e.g. "22"
 */
export function hexWithAlphaSuffix(hex, alphaHex) {
  if (!hex || !hex.startsWith("#") || hex.length !== 7) return hex;
  return `${hex}${alphaHex}`;
}

/**
 * Build legacy `C` object from a semantic palette (injected CSS / inline styles).
 * @param {typeof darkColors} palette
 */
export function buildLegacyMatchTokens(palette) {
  return Object.freeze({
    bg: palette.background,
    bgMid: palette.backgroundMid,
    bgTop: palette.backgroundTop,
    surf: palette.surface,
    card: palette.surfaceRaised,
    bdr: palette.borderStrong,
    bdrSoft: palette.border,
    bdrBr: palette.borderBright,
    sA: palette.teamA,
    sAd: hexWithAlphaSuffix(palette.teamA, "22"),
    sB: palette.teamB,
    sBd: hexWithAlphaSuffix(palette.teamB, "22"),
    gr: palette.primary,
    grd: hexWithAlphaSuffix(palette.primary, "22"),
    grDim: palette.primaryMuted,
    net: palette.courtNet,
    acc: palette.accent,
    accd: hexWithAlphaSuffix(palette.accent, "22"),
    txt: palette.text,
    txtM: palette.textMuted,
    txtD: palette.textDim,
    lav: palette.textSecondary,
    win: palette.success,
    winD: hexWithAlphaSuffix(palette.success, "22"),
    loss: palette.danger,
    lossD: hexWithAlphaSuffix(palette.danger, "22"),
    orange: palette.accent,
    purple: palette.purple,
  });
}

/** Resolve `var(--tra-*)` reference for a legacy key (use in new CSS-in-JS). */
export function legacyCssVar(legacyKey) {
  const name = LEGACY_C_KEYS_TO_CSS_VAR[legacyKey];
  return name ? `var(${name})` : undefined;
}

/** Default legacy tokens — dark production palette (matches pre-bridge `matchTokens.js`). */
export const C = buildLegacyMatchTokens(darkColors);

export function getLegacyMatchTokens(themeId = "dark") {
  return buildLegacyMatchTokens(themeId === "light" ? lightColors : darkColors);
}
